import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useCart = create(
  persist(
    (set, get) => ({
      items: [], // [{ product_id, name, price, image, quantity }]
      open: false,
      setOpen: (v) => set({ open: v }),
      add: (product, qty = 1) => {
        const items = get().items;
        const existing = items.find((i) => i.product_id === product.id);
        const orig = Number(product.price) || 0;
        const onSale = Boolean(
          product.on_sale && product.sale_price != null &&
          Number(product.sale_price) > 0 && Number(product.sale_price) < orig
        );
        const effectivePrice = onSale ? Number(product.sale_price) : orig;
        if (existing) {
          set({
            items: items.map((i) =>
              i.product_id === product.id
                ? { ...i, quantity: i.quantity + qty, price: effectivePrice, original_price: orig, on_sale: onSale }
                : i
            ),
            open: true,
          });
        } else {
          set({
            items: [
              ...items,
              {
                product_id: product.id,
                name: product.name,
                price: effectivePrice,
                original_price: orig,
                on_sale: onSale,
                image: product.images?.[0] || "",
                quantity: qty,
              },
            ],
            open: true,
          });
        }
      },
      remove: (productId) =>
        set({ items: get().items.filter((i) => i.product_id !== productId) }),
      updateQty: (productId, quantity) => {
        if (quantity < 1) return;
        set({
          items: get().items.map((i) =>
            i.product_id === productId ? { ...i, quantity } : i
          ),
        });
      },
      clear: () => set({ items: [] }),
      total: () =>
        get().items.reduce((s, i) => s + i.price * i.quantity, 0),
      count: () =>
        get().items.reduce((s, i) => s + i.quantity, 0),
    }),
    { name: "dcb-cart" }
  )
);
